import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const wrapper: React.CSSProperties = {
  ...sharedStyles.column,
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
  width: '130px',
  height: '84px',
}

export const wrapperHover = {
  ...wrapper,
  backgroundColor: sharedStyles.Colors.HOVER,
}

export const counter = {
  ...sharedStyles.heading,
  ...sharedStyles.textPrimary,
}

export const title = {
  ...sharedStyles.small,
  ...sharedStyles.textSecondary,
}
